import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../../libs/shared/ui/src/components/utility/skeleton';

const StyledContactHeaderLoadingSkeletonContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  padding: 16px;
  height: 80px;
`;

const StyledContactHeaderLoadingIconDiv = styled.div`
  flex: 0 0 60px;
`;

const StyledContactHeaderLoadingNameDiv = styled.div`
  flex: 1;
  padding-top: 14px;
`;

export const ContactDetailsHeaderLoadingSkeleton: FC = () => (
  <StyledContactHeaderLoadingSkeletonContainerDiv>
    <StyledContactHeaderLoadingIconDiv>
      <Skeleton width="48px" height="48px" borderRadius="50%" />
    </StyledContactHeaderLoadingIconDiv>
    <StyledContactHeaderLoadingNameDiv>
      <Skeleton height="20px" />
    </StyledContactHeaderLoadingNameDiv>
  </StyledContactHeaderLoadingSkeletonContainerDiv>
);
